import { ChangeDetectorRef, Component, Input, OnChanges, OnDestroy, OnInit, SimpleChanges } from '@angular/core';
import { ProductGet, ProductKpiDataItem, ProductService } from '@app/services/product.service';
import { from, ReplaySubject, Subject, switchMap, takeUntil } from 'rxjs';

@Component({
    selector: 'tt-product-kpi-form',
    templateUrl: './product-kpi-form.component.html',
    styleUrls: ['./product-kpi-form.component.css'],
})
export class ProductKpiFormComponent implements OnInit, OnChanges, OnDestroy {
    @Input()
    public set params(value: ProductGet | undefined) {
        this.setParams(value);
    }
    public get params() {
        return this._params;
    }
    private _params?: ProductGet;
    private setParams(value: ProductGet | undefined) {
        this._params = value;
        if (!!value) {
            this.params$.next(value);
        }
    }

    private destroy$ = new Subject<void>();

    private params$ = new ReplaySubject<ProductGet>(1);

    public kpiData: ProductKpiDataItem[] = [];

    constructor(
        private product: ProductService,
        private cdr: ChangeDetectorRef,
    ) {}
    private setupParamsSubscriptions() {
        this.params$
            .pipe(
                switchMap((params) => from(this.product.getProductKpiDatas(params))),
                takeUntil(this.destroy$),
            )
            .subscribe((kpiData) => {
                this.kpiData = kpiData;
                this.cdr.markForCheck();
            });
    }

    ngOnInit(): void {
        this.setupParamsSubscriptions();
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (!!changes['params']) {
            this.params = changes['params'].currentValue;
        }
    }

    ngOnDestroy(): void {
        this.destroy$.next();
        this.destroy$.complete();
    }
}
